import get from "lodash/get";
import React, { useState } from "react";
import set from "@rill/set";
import Select from "../../../parts/inputs/select";

function View(props, { locals }) {
  const { activeUser } = locals;
  const [selected, setSelected] = useState("Billing");
  const [message, setMessage] = useState("");
  return (
    <main role="reports-wrapper" className="support contact">
      <article role="report-content">
        <header>
          <h3>Contact us</h3>
          <p className="guide-text">
            Please fill out the contact form and we will be in touch shortly
          </p>
        </header>
        <form id="form-contact" method="POST">
          <input type="hidden" name="name" value={get(activeUser, "name")} />
          <input type="hidden" name="email" value={get(activeUser, "email")} />
          <input type="hidden" name="isFromWeb" value={true} />
          <Select
            name="type"
            title="Type of inquiry"
            options={[
              { value: "Billing", text: "Billing" },
              { value: "Technical", text: "Technical" },
              { value: "Business", text: "Business" },
              { value: "Marketing", text: "Marketing" },
              { value: "Feedback", text: "Feedback" },
              { value: "Other", text: "Other" },
            ]}
            value={selected}
            onChange={(val) => setSelected(val)}
          />
          <textarea
            className="textarea-input"
            placeholder="Message*"
            required
            name="message"
            onInput={(e) => setMessage(e.target.value)}
          />

          <button data-button-type="primary" disabled={!message} type="submit">
            Send
          </button>
        </form>
      </article>
    </main>
  );
}

const Contact = (app) => {
  app
    .post("/contact", async ({ req, res, api, flash, assert }) => {
      const { body } = req;
      assert(body.type, 400, "You must pick a type of inquiry");
      assert(body.message, 400, "You must type a message");
      flash("success", "Successfully sent");
      await api("contact", { method: "POST", body });
      return res.backDontScroll();
    })
    .get(
      "/contact",
      set("heading", ["Contact Us"]),
      ({ res }) => (res.body = <View />)
    );
};

export default Contact;
